'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('mail-template-list', {
      url: '/admin/mail-template/list',
      template: '<mail-template-list></mail-template-list>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/messaging/mail/template/list/mail-template-list.routes.js